import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-221">
      <div className="max-w-4xl mx-auto" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-yellow/10 rounded-3xl p-8 md:p-12 text-center relative" data-id="element-223">
          <Quote className="absolute top-6 left-6 text-brand-yellow/30 w-16 h-16 -z-10 rotate-180" data-id="element-224" />
          <Quote className="absolute bottom-6 right-6 text-brand-yellow/30 w-16 h-16 -z-10" data-id="element-225" />

          <p className="text-xl md:text-2xl font-heading font-bold text-brand-dark leading-relaxed relative z-10" data-id="element-226">
            "En solo 7 días, pasarás de no saber qué es un 'Prompt' a crear un
            plan de estudio personalizado para un mes entero en menos de 5
            minutos, recuperando tiempo de calidad y ganando el respeto de tus
            alumnos o hijos como su guía digital."
          </p>
        </motion.div>
      </div>
    </section>;
}